import { render, staticRenderFns } from "./Sensor.vue?vue&type=template&id=263e5e78&scoped=true&"
import script from "./Sensor.vue?vue&type=script&lang=js&"
export * from "./Sensor.vue?vue&type=script&lang=js&"
import style0 from "./Sensor.vue?vue&type=style&index=0&id=263e5e78&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263e5e78",
  null
  
)

/* custom blocks */
import block0 from "./Sensor.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('263e5e78')) {
      api.createRecord('263e5e78', component.options)
    } else {
      api.reload('263e5e78', component.options)
    }
    module.hot.accept("./Sensor.vue?vue&type=template&id=263e5e78&scoped=true&", function () {
      api.rerender('263e5e78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Sensor/Sensor.vue"
export default component.exports